type HapticOptions = {
  enableVibrateFallback?: boolean
  ignoreAndroidSystemSettings?: boolean
}

const patterns: Record<string, number | number[]> = {
  selection: 10,
  impactLight: 15,
  impactMedium: 25,
  impactHeavy: 40,
  notificationSuccess: [10, 40, 10],
  notificationWarning: [20, 30, 20],
  notificationError: [30, 20, 30, 20],
  rigid: 20,
  soft: 8,
}

/** Chrome 要求用户先与页面交互后才允许 vibrate，否则控制台会报 Intervention */
let userHasInteracted = false

function markUserInteracted() {
  userHasInteracted = true
}

if (typeof window !== "undefined") {
  window.addEventListener("pointerdown", markUserInteracted, { once: true, passive: true })
  window.addEventListener("keydown", markUserInteracted, { once: true, passive: true })
}

export default {
  trigger(type: string, _options?: HapticOptions) {
    if (!userHasInteracted) return
    if (typeof navigator === "undefined" || !navigator.vibrate) return
    const pattern = patterns[type] ?? 15
    try {
      navigator.vibrate(pattern)
    } catch {
      // blocked or unsupported
    }
  },
}
